import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { NavigationLibraryService } from 'src/app/shared/services/navigation/navigation.service';

@Component({
  selector: 'app-tvod-payment-not-allowed',
  templateUrl: './tvod-payment-not-allowed.html',
  styleUrls: ['./tvod-payment-not-allowed.scss'],
})
export class TvodPaymentNotAllowedComponent {
  constructor(
    private dialogService: DialogService,
    private readonly navigationService: NavigationLibraryService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.navigationService.focusContainer('actions', true, 0, true);
  }

  onClose() {
    if (this.data?.action === 'go-back') {
      this.dialogService.closeWithResult(true);
    } else {
      this.dialogService.closeAll();
    }
    this.navigationService.focus(150);
  }

  disabled(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.isUp() || event.isDown()) {
      this.disabled(event);
    }
  }
}
